import RequireAuth from "@/components/hoc/RequireAuth";
import RootLayout from "@/components/layout/RootLayout";
import useInjectSidebar from "@/hooks/useInjectSidebar";
import Information from "@/pages/project/_id/Information";
import ProjectViewerLayout from "@/pages/project/_id/ProjectViewerLayout";
import ProjectSettingLayout from "@/pages/project/_id/setting/ProjectSettingLayout";
import ProjectSettingGeneral from "@/pages/project/_id/setting/general/ProjectSettingGeneral";
import ProjectSettingMember from "@/pages/project/_id/setting/member/ProjectSettingMember";
import ProjectTemplateList from "@/pages/project/new";
import { Navigate } from "react-router-dom";
import ProjectSettingInformation from "../pages/project/_id/setting/information/ProjectSettingInformation";
import ProjectCreateNewFlagship from "@/pages/project/new/flagship/ProjectCreateNewFlagship";

const AppLayout = () => {
    const root = useInjectSidebar({ sidebarName: "workspace" })(RootLayout);

    return <RequireAuth>{root}</RequireAuth>;
};

export const projectRoute = {
    path: "/projects",
    element: <AppLayout />,
    children: [
        {
            path: ":projectId",
            element: <ProjectViewerLayout />,
            children: [
                {
                    index: true,
                    element: <Navigate to="./info" replace={true} />,
                },
                {
                    path: "info",
                    element: <Information />,
                },
                {
                    path: "settings",
                    element: <ProjectSettingLayout />,
                    children: [
                        {
                            index: true,
                            element: <Navigate to="./general" replace={true} />,
                        },
                        {
                            path: "general",
                            element: <ProjectSettingGeneral />,
                        },
                        {
                            path: "info",
                            element: <ProjectSettingInformation />,
                        },
                        {
                            path: "members",
                            element: <ProjectSettingMember />,
                        },
                    ],
                },
            ],
        },
        {
            path: "new",
            element: <ProjectTemplateList />,
        },
        {
            path: "new/flagship",
            element: <ProjectCreateNewFlagship />,
        },
    ],
};
